const selectZoom=state=>state.ui.zoom;


export {
    selectZoom
}